import React from 'react';
import { Apple } from 'lucide-react';
import WhyPanel from './WhyPanel';

/**
 * NutritionWhyPanel — synthesized WHY for the /nutrition page. Reads
 * `nutrition_insight` from /api/wellness/iq (built by compute_nutrition_insight
 * in wellness.py). Same shape + look as the other pillar Why panels.
 */
const NutritionWhyPanel = ({ insight, score, onActionClick }) => (
  <WhyPanel
    insight={insight}
    icon={Apple}
    color="#fb923c"
    title={`WHY YOUR NUTRITION IS${score != null ? '' : ' WHERE IT IS'}`}
    score={score}
    testIdPrefix="nutrition-why-panel"
    onActionClick={onActionClick}
    emptyMessage="Set your targets first — your stats, goal, and activity. Then log a few meals and I'll read your fueling on a rolling 3-day window."
  />
);

export default NutritionWhyPanel;
